"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { X } from "lucide-react";
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const employees = [{
  name: "John Goodwin\xA0",
  position: "Chief Executive Officer / Strategist",
  bio: "Specializes in organizational development and capacity building within higher education.",
  image: "https://esgnewdesign.10web.cloud/wp-content/uploads/2026/03/John-headshot.jpg?v=eij2fv5n7z5"
}, {
  name: "Brad Gibbs",
  position: "Chief Growth Officer / Strategist",
  bio: "Expert in designing learner-centered ecosystems that enhance retention and engagement.",
  image: "https://esgnewdesign.10web.cloud/wp-content/uploads/2026/03/Brad-Headshot.png?v=8cmwyjfrxp"
}, {
  name: "Richard Novak\xA0",
  position: "Chief Academic Officer / Strategist",
  bio: "Expert in brokering and managing high-impact collaborations between academic departments and external stakeholders.",
  image: "https://esgnewdesign.10web.cloud/wp-content/uploads/2026/03/richnovak-headshot-1-scaled.jpg?v=tsfjdlbd14l"
}, {
  name: "Joe Barnard",
  position: "Chief Technology Officer / Strategist",
  bio: "Provides data-driven insights to inform lifelong learning strategies and measure long-term impact.",
  image: "https://esgnewdesign.10web.cloud/wp-content/uploads/2026/03/Joe_outdoor_update-scaled.jpg?v=9d99z81mf6"
}];
export default function OurTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-team" className="bg-background py-16 relative overflow-hidden">
      {}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-accent/10 -skew-x-12 translate-x-1/3 pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10" ref={ref}>
        <div className={`transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="mb-16 max-w-3xl">
            <h2 className="text-primary font-serif text-4xl md:text-5xl font-bold mb-6">
              Our Team
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl max-w-2xl">
              We are a collective of educators, strategists, and designers
              dedicated to building capability, not dependency.
            </p>
          </div>

          <div className="flex flex-row flex-nowrap gap-8 overflow-x-auto pb-8">
            {employees.map((emp, i) => <SafeHydrate><Drawer key={i} direction="right">
                <DrawerTrigger asChild>
                  <Button variant="ghost" className="group w-72 md:w-80 shrink-0 h-auto p-0 hover:bg-transparent flex flex-col items-start justify-start whitespace-normal rounded-none" data-index={i}>
                    <Card className="w-full h-full border-none shadow-none bg-transparent overflow-visible">
                      <CardContent className="p-0 text-left">
                        <div className="relative aspect-[3/4] overflow-hidden rounded-sm mb-6 bg-muted w-full">
                          <img src={emp.image} alt={emp.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out" />
                          {}
                          <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/5 transition-colors duration-500" />
                        </div>
                        <div className="space-y-1 w-full">
                          <h3 className="text-primary font-serif text-2xl font-bold group-hover:text-secondary transition-colors duration-300">
                            {emp.name}
                          </h3>
                          <p className="text-secondary font-sans font-medium text-lg">
                            {emp.position}
                          </p>
                        </div>
                      </CardContent>
                    </Card>
                  </Button>
                </DrawerTrigger>

                <DrawerContent className="h-full max-w-md ml-auto rounded-l-xl rounded-r-none border-l border-border bg-background shadow-2xl outline-none">
                  <div className="h-full overflow-y-auto p-0 flex flex-col">
                    {}
                    <div className="relative h-72 shrink-0 w-full">
                      <img src={emp.image} alt={emp.name} className="w-full h-full object-cover" />
                      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/20 to-transparent" />
                      <DrawerClose asChild>
                        <Button variant="ghost" size="icon" className="absolute top-4 right-4 bg-background/80 hover:bg-background text-foreground rounded-full backdrop-blur-sm shadow-sm z-50">
                          <X className="h-5 w-5" />
                          <span className="sr-only">Close</span>
                        </Button>
                      </DrawerClose>
                    </div>

                    {}
                    <div className="px-8 pb-12 -mt-12 relative z-10">
                      <DrawerHeader className="p-0 mb-8 text-left space-y-2">
                        <DrawerTitle className="text-3xl md:text-4xl font-serif text-primary leading-tight">
                          {emp.name}
                        </DrawerTitle>
                        <DrawerDescription className="text-lg md:text-xl text-secondary font-medium">
                          {emp.position}
                        </DrawerDescription>
                      </DrawerHeader>

                      <div className="prose prose-lg text-muted-foreground leading-relaxed">
                        <p>{emp.bio}</p>
                      </div>
                    </div>
                  </div>
                </DrawerContent>
              </Drawer></SafeHydrate>)}
          </div>
        </div>
      </div>
    </section>;
}